export default __webpack_public_path__ + "static/media/background.894ab26b.jpg";